import { CardSwapSearchResultDto } from "../dtos/CardSwapSearchResultDto";
import { Dialog, Stack, DialogContent, DialogActions, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { DialogTitleClosable } from "../../../components/DialogTitleClosable";
import { bhpButtonSx } from "../../../styles/bhpStyles";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CancelIcon from '@mui/icons-material/Cancel';
import { cardSwapStatusCodes } from "../enums/CardSwapStatusCode";
import { formatDateTime } from "../../../utils";
import { useCardSwap } from "../hooks/useCardSwap";


type CardSwapFinalDialogProps = {

    cardSwapSearchResultDto : CardSwapSearchResultDto;
    dialogOpen: boolean;
    onClose: ( isUpdated : boolean ) => void;

};


export const CardSwapFinalDialog : React.FC< CardSwapFinalDialogProps > = ( props : CardSwapFinalDialogProps ) => {

    
    const { cardSwapSearchResultDto, dialogOpen, onClose } = props;

    const { cardSwapSearchResult } = useCardSwap( cardSwapSearchResultDto );

    
    const handleClose = ( ) => onClose( false );


    return(

        <Dialog
            onClose={ handleClose }
            open={ dialogOpen }
            sx={{ '& .MuiDialog-paper': { minHeight: 435, width: '500px' } }}
        >
            <DialogTitleClosable onClose={ handleClose }>
                <Stack direction="row" display="flex" alignItems="center" gap={ 0.5 }>
                    <CreditCardIcon /> 
                    { cardSwapStatusCodes[ cardSwapSearchResultDto.refCardSwapStatusCode ] }
                </Stack>
            </DialogTitleClosable>

            <DialogContent dividers>
                
                <ul>

                    <li><b>First Name:</b> { cardSwapSearchResult.firstName }</li>
                    <li><b>Last Name:</b> { cardSwapSearchResult.surname }</li>
                    <li><b>Email:</b> { cardSwapSearchResult.email }</li>
                    <li><b>Employee / ERMS ID:</b> { cardSwapSearchResult.employeeNumber }</li>
                    <li><b>Card Collection Village:</b> { cardSwapSearchResult.villageCode }</li>

                </ul>

                <h2>New Card</h2>
                <TableContainer component={ Paper } sx={{ marginTop:'10px', overflowY: 'hidden' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" sx={{ fontWeight: 'bold' }}>Card Number</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 'bold' }}>Collected</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell align="center">{ cardSwapSearchResult.newCardNumber }</TableCell>
                                <TableCell align="center">
                                    { cardSwapSearchResult.newCardCollectedDate ? formatDateTime( new Date( cardSwapSearchResult.newCardCollectedDate ) ) : '-' }
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

                <h2>Old Cards</h2>

                <TableContainer component={ Paper } sx={{ marginTop:'10px', overflowY: 'hidden' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" sx={{ fontWeight: 'bold', width: '50px' }}>Card Number</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 'bold' }}>Returned</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 'bold' }}>Deactivated</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                cardSwapSearchResult.oldCards.map( oldCard =>
                                    <TableRow key={ oldCard.cardNumber } sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer' }} hover >
                                        <TableCell align="center">{ oldCard.cardNumber }</TableCell>
                                        <TableCell align="center">
                                            { oldCard.returnedDateTime ? formatDateTime( new Date( oldCard.returnedDateTime ) ) : '-' }
                                        </TableCell>
                                        <TableCell align="center">
                                            { oldCard.deactivatedDateTime ? formatDateTime( new Date( oldCard.deactivatedDateTime ) ) : '-' }
                                        </TableCell>
                                    </TableRow>
                                )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>


            </DialogContent>
            
            <DialogActions>

                <Button 
                    onClick={ handleClose } 
                    startIcon={ <CancelIcon /> }
                    sx={{ ...bhpButtonSx, width: '100px' }} 
                >
                    Close
                </Button>

            </DialogActions>

        </Dialog>


    );

};